"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _logoUpload = require('./logoUpload');

/* The crop step's shapes and the size each crop is exported at (D-27),
 * matching what the server stores (apps/backend/pkg/image/logo.go): a wide
 * logo fits within 960 x 240, a square one is 512 x 512. Neither is scaled
 * up past the cropped source; the server still checks, pads and re-encodes
 * whatever arrives. */

 const WIDE_ASPECT_RANGE = [1, 8] ; exports.WIDE_ASPECT_RANGE = WIDE_ASPECT_RANGE
const WIDE_BOX = { width: 960, height: 240 }
const MIN_WIDE_WIDTH = 240
const SQUARE_EDGE = 512
const MIN_SQUARE_EDGE = 192

 const TOO_NARROW = 'The logo must be at least 240 pixels wide'; exports.TOO_NARROW = TOO_NARROW
// The export, not the picked file, is what's over 1 MB.
const TOO_BIG = 'This crop is too detailed to upload. Try a simpler image or a smaller crop.'
// The server's words for a square logo under 192 px, naming the team logo
// for a team.
 const tooSmallSquare = (kind) =>
  `The ${kind === 'team' ? 'team logo' : 'icon'} must be at least ${MIN_SQUARE_EDGE} by ${MIN_SQUARE_EDGE} pixels`; exports.tooSmallSquare = tooSmallSquare



// The pixel size a crop of width x height (source pixels) is exported at,
// or the reason it can't be.
 const logoExportSize = (kind, width, height) => {
  const w = Math.round(width)
  const h = Math.round(height)
  if (w <= 0 || h <= 0) return "The image couldn't be read"
  if (kind === 'logo') {
    const scale = Math.min(1, WIDE_BOX.width / w, WIDE_BOX.height / h)
    const width = Math.max(1, Math.round(w * scale))
    // Held to the server's shape, square to 8:1, whatever the rounding did.
    const height = Math.min(width, Math.max(Math.ceil(width / exports.WIDE_ASPECT_RANGE[1]), Math.round(h * scale)))
    return width < MIN_WIDE_WIDTH ? exports.TOO_NARROW : { width, height }
  }
  const edge = Math.min(SQUARE_EDGE, w, h)
  return edge < MIN_SQUARE_EDGE ? exports.tooSmallSquare.call(void 0, kind) : { width: edge, height: edge }
}; exports.logoExportSize = logoExportSize

// "logo.jpeg" → "logo.png": the export is always a PNG.
 const pngName = (name) => `${name.replace(/\.[^./]*$/, '') || 'logo'}.png`; exports.pngName = pngName

const toPng = (canvas) =>
  new Promise(resolve => canvas.toBlob(resolve, 'image/png'))

// cropperjs copies the source to a canvas first; capping it keeps a large
// phone photo under iOS Safari's canvas limit (about 16.7 MP). The export
// is far smaller.
const MAX_SOURCE_EDGE = 4096

// The crop drawn into a canvas of exactly size. cropperjs fits a requested
// size to the box's unrounded shape and truncates, which can come out a
// pixel short of what the server accepts, so it draws the crop at its own
// size and this scales it.
const drawAt = (source, size) => {
  const canvas = document.createElement('canvas')
  canvas.width = size.width
  canvas.height = size.height
  const context = canvas.getContext('2d')
  if (!context) return null
  context.imageSmoothingEnabled = true
  context.imageSmoothingQuality = 'high'
  context.drawImage(source, 0, 0, size.width, size.height)
  return canvas
}

// The crop as an upload-ready PNG at its export size, or the reason it can't be.
 const exportLogoCrop = async (cropper, kind, sourceName) => {
  const { width, height } = cropper.getData()
  const size = exports.logoExportSize.call(void 0, kind, width, height)
  if (typeof size === 'string') return size
  const crop = cropper.getCroppedCanvas({
    maxWidth: MAX_SOURCE_EDGE, maxHeight: MAX_SOURCE_EDGE, imageSmoothingEnabled: true, imageSmoothingQuality: 'high',
  })
  const canvas = crop && drawAt(crop, size)
  const blob = canvas && await toPng(canvas)
  if (!blob) return "The image couldn't be read"
  if (blob.size > _logoUpload.MAX_LOGO_BYTES) return TOO_BIG
  return new File([blob], exports.pngName.call(void 0, sourceName), { type: 'image/png' })
}; exports.exportLogoCrop = exportLogoCrop
